module.exports = __webpack_public_path__ + "img/send_email.8e442430.svg";